export const state = () => ({
  uncubesServerReady: false,
  kpiStorage: []
});
